import React, { Component } from 'react';
import '../componentform.css';
import componentFormService from '../ComponentFormService.js';
import componentMap from '../../../ComponentMap';
import { showConfirmation } from '../../../ConfirmationModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faEdit, faTrashAlt, faEllipsisV, faEye } from '@fortawesome/free-solid-svg-icons';
import ComponentFormPopup from '../ComponentFormPopup';
import ColumnsTabForm from './ColumnsTabForm';
import DnDColumnsTab from './DnDColumnsTab';
import FakeDnDColumnsTab from './FakeDnDColumnsTab';
import { showNotification } from '../../../StatusNotification';

export class ColumnsTabContainerForm extends Component {
    static displayName = ColumnsTabContainerForm.name;

    constructor(props) {
        super(props);
        this.state = {
            columnsTabContainer: null,
            columnsTabs: [],
            formType: null,
            pageId: this.props.pageId,
            versionId: this.props.versionId,
            versionStatus: this.props.versionStatus,
            isEditOnly: this.props.isEditOnly != undefined ? this.props.isEditOnly : false,
            isInPopup: this.props.isInPopup != undefined ? this.props.isInPopup : false,
            popup: null,
            reset: false
        };
        this.displayPopup = this.displayPopup.bind(this);
        this.cancelClicked = this.cancelClicked.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.deleteColumnsTab = this.deleteColumnsTab.bind(this);
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newColumnsTabContainer = this.state.columnsTabContainer;

        if (e.target.name == "isAccordion" || e.target.name == "showBorder") {
            newColumnsTabContainer[e.target.name] = e.target.checked ? true : false;
        }
        else {
            newColumnsTabContainer[e.target.name] = e.target.value;
        }

        this.setState({ columnsTabContainer: newColumnsTabContainer });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let columnsTabContainer = this.state.columnsTabContainer;
        columnsTabContainer.versionId = this.state.versionId;
        columnsTabContainer.pageId = this.state.pageId;

        let url = this.state.formType == "Update" ? "UpdateColumnsTabContainer" : "CreateColumnsTabContainer";
        fetch('Admin/' + url, {
            method: 'POST',
            body: JSON.stringify(columnsTabContainer),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (!isNaN(data)) {
                    if (!this.state.isEditOnly) {
                        var pageComponentId = this.props.pageComponentId != undefined ? this.props.pageComponentId : 0;
                        var isDataSaved = componentFormService.managePageComponent(this.state.pageId, "ColumnsTabContainer", parseInt(data), parseInt(pageComponentId), this.state.versionId, this.state.versionStatus);
                    }

                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        );
    }

    displayPopup = (columnsTabId, formType) => {
        let popupForm = <ColumnsTabForm
            componentId={columnsTabId}
            formType={formType}
            pageId={this.state.pageId}
            pageComponentId={this.props.pageComponentId}
            versionStatus={this.state.versionStatus}
            versionId={this.state.versionId}
            onComponentSaved={this.onPopupComponentSaved.bind(this)}
            isEditOnly={true}
            isInPopup={true}
            columnsTabContainerId={this.state.columnsTabContainer.id}
        />;

        let popup = <ComponentFormPopup
            popupForm={popupForm}
            cancelClicked={this.cancelClicked.bind(this)}
        />;

        this.setState({
            popup: popup
        });
    }

    onPopupComponentSaved() {
        showNotification("Saved", "success");

        this.setState({
            reset: true,
            popup: null
        });
        this.getComponentData();
    }

    cancelClicked() {
        this.setState({
            popup: null
        });
    }

    async columnsTabOrderUpdate(componentArray) {
        let componentIdsOrdered = [];
        for (var i = 0; i < componentArray.length; i++) {
            componentIdsOrdered.push(parseInt(componentArray[i].id));
        }

        const response = await fetch('Admin/UpdateColumnsTabComponentOrder', {
            method: 'POST',
            body: JSON.stringify({ "columnsTabIds": componentIdsOrdered }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        if (data != "Saved") {
            showNotification(data, "error");
        }
    }

    async deleteColumnsTab(columnsTabId) {
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteColumnsTab?componentId=' + columnsTabId, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                this.setState({
                    reset: true
                });
                this.getComponentData();
            }
            else {
                showNotification(data, "error");
            }
        }
    }

    render() {
        let deleteButton = this.state.formType == "Update" ? <button className='delete-btn' onClick={this.deleteComponent.bind(this)}>Delete</button> : null;
        if (this.state.isInPopup) {
            deleteButton = null;
        }

        let componentName = null;
        let isAccordion = false;
        let showBorder = false;

        if (this.state.columnsTabContainer != null) {
            let columnsTabContainer = this.state.columnsTabContainer;

            componentName = columnsTabContainer.componentName;
            isAccordion = columnsTabContainer.isAccordion;
            showBorder = columnsTabContainer.showBorder;
        }

        let mainFormClasses = "tri-grid";
        let sideMenu;
        let addNewColumnsTabButton = null;
        let columnsTabButtons = [];
        if (this.state.formType == "Update") {
            addNewColumnsTabButton = this.state.versionStatus == 'draft' ?
                <button type="button" onClick={this.displayPopup.bind(this, 0, 'Create')} className='side-menu-button'>Add Tab</button> : "";

            for (var i = 0; i < this.state.columnsTabs.length; i++) {
                let columnsTab = this.state.columnsTabs[i];

                let columnsTabKey = "columnsTab" + i;

                let currentComponentManagementBtns = this.state.versionStatus == 'draft' ?
                    <>
                        <button type="button" className='current-component__edit' onClick={this.displayPopup.bind(this, columnsTab.id, 'Update')} aria-label="Edit"><FontAwesomeIcon icon={faEdit} aria-hidden="true" /></button>
                        <button type="button" className='current-component__delete' onClick={this.deleteColumnsTab.bind(this, columnsTab.id)} aria-label="Delete"><FontAwesomeIcon icon={faTrashAlt} aria-hidden="true" /></button>
                    </> :
                    <>
                        <button type="button" className='current-component__view' onClick={this.displayPopup.bind(this, columnsTab.id, 'Update')} aria-label="View"><FontAwesomeIcon icon={faEye} aria-hidden="true" /></button>
                    </>;

                let columnsTabBtnClasses = this.state.versionStatus == 'draft' ? 'sub-component-button' : 'sub-component-button disable-dnd';

                let columnsTabBtn =
                    <div key={columnsTabKey} className={columnsTabBtnClasses}>

                        {columnsTab.componentName}

                        <div className='current-component__manage'>
                            {currentComponentManagementBtns}
                        </div>
                    </div>;

                columnsTabButtons.push({ id: columnsTab.id.toString(), content: columnsTabBtn });
            }

            let columnsTabDnD = (this.state.versionStatus == 'draft') ?
                <DnDColumnsTab items={columnsTabButtons} itemOrderUpdate={this.columnsTabOrderUpdate.bind(this)} /> :
                <FakeDnDColumnsTab items={columnsTabButtons} />;

            if (this.state.reset) {
                columnsTabDnD = "";
            }

            sideMenu = <div className='side-menu' style={{ paddingRight: '0%' }}>
                {addNewColumnsTabButton}
                {columnsTabDnD}
            </div>;
        }
        else {
            mainFormClasses += " dual-grid__1-2";
        }

        let wrapperClasses = this.state.versionStatus == 'draft' ? 'grid-wrapper component-form' : 'grid-wrapper component-form disable-form';
        return (
            <div className={wrapperClasses}>
                {this.state.popup}

                <form onSubmit={this.handleSubmit}>
                    <div className='dual-grid'>
                        {sideMenu}

                        <div className={mainFormClasses}>
                            <div className='tri-grid__1-3 form-title'>
                                <h2>{componentName} {componentMap.componentTypeDisplay('ColumnsTabContainer')}</h2>
                            </div>

                            <label htmlFor='colTabContainer-componentName'>Component Name:</label>
                            <input id='colTabContainer-componentName' name='componentName' type='text' defaultValue={componentName} onChange={this.handleChange} required maxLength='15' />
                            <div></div>

                            <label htmlFor='isAccordion'>Display As Accordion: </label>
                            <div className='checkbox-wrapper'>
                                <input id='isAccordion' name='isAccordion' type='checkbox' checked={isAccordion} onChange={this.handleChange} />
                            </div>
                            <div></div>

                            <label>Show Border: </label>
                            <div className='checkbox-wrapper'>
                                <input id='showBorder' name='showBorder' type='checkbox' checked={showBorder} onChange={this.handleChange} />
                            </div>
                            <div></div>

                            <div className='tri-grid__1-3'>
                                <button type='submit'>Save</button>
                                {deleteButton}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    async getComponentData() {
        let componentId = (this.props.componentId !== undefined) ? this.props.componentId : 0;
        let formType = this.props.formType !== undefined ? this.props.formType : 'Create';

        const response = await fetch('Admin/GetColumnsTabContainer?componentId=' + componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            columnsTabContainer: data.columnsTabContainer,
            columnsTabs: data.columnsTabs,
            formType: formType,
            reset: false,
        });
    }

    async deleteComponent(e) {
        e.preventDefault();
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteColumnsTabContainer?componentId=' + this.state.columnsTabContainer.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                this.props.onComponentDeleted();
            }
            else {
                showNotification(data, "error");
            }
        }
    }
}

export default ColumnsTabContainerForm;
